import { forwardRef } from 'react';

import { Select as HeadlessSelect } from '@headlessui/react';

import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface IOption {
  value: number;
  label: string;
}

interface ISelectProps {
  options?: IOption[];
  defaultValue?: string;
}

const Select = forwardRef<HTMLSelectElement, ISelectProps>(
  ({ options, defaultValue }, ref) => {
    return (
      <div className="flex flex-col gap-1 w-[383px]">
        <label
          htmlFor="status"
          className="text-lg font-jostRegular text-[#1F2B40CC]">
          Rolle
        </label>

        <div className="relative">
          <HeadlessSelect
            ref={ref}
            id="status"
            name="status"
            defaultValue={defaultValue}
            className="appearance-none w-full rounded-xl py-3 px-2 
                       text-xl text-[#1F2B40] 
                       border border-[#1F2B40]
                       focus:outline-none">
            {options?.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </HeadlessSelect>

          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="h-5 w-5 text-[#1F2B40]" />
          </div>
        </div>
      </div>
    );
  }
);

export default Select;
